export default "__VITE_ASSET__a2aba6b9__"